// src/pages/LoginPage.jsx

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

function LoginPage() {
  const { login, authError } = useAuth();

  const [form, setForm] = useState({
    email: "",
    password: "",
  });

  const [submitting, setSubmitting] = useState(false);

  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setSubmitting(true);

      await login(
        form.email.trim(),
        form.password
      );

      // ✅ Après connexion :
      // toujours afficher le Dashboard
      navigate("/admin/dashboard", {
        replace: true,
      });
    } catch (err) {
      // L'erreur est déjà gérée dans AuthContext
      console.error(
        "Erreur connexion admin :",
        err
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      className="bg-light d-flex align-items-center"
      style={{
        minHeight: "80vh",
      }}
    >
      <div
        className="container py-5"
        style={{
          maxWidth: 430,
        }}
      >
        {/* Logo / entête */}

        <div className="text-center mb-4">
          <div
            className="mx-auto mb-3 bg-white shadow-sm d-flex align-items-center justify-content-center rounded-4"
            style={{
              width: 70,
              height: 70,
            }}
          >
            <span
              className="fw-bold text-primary"
              style={{
                fontSize: 22,
              }}
            >
              PS
            </span>
          </div>

          <h4 className="fw-bold mb-1">
            Administration
          </h4>

          <p className="text-muted small mb-0">
            ProSoft Tools
          </p>
        </div>

        {/* Carte connexion */}

        <div className="card shadow-sm border-0 rounded-4">
          <div className="card-body p-4">
            <h5 className="fw-bold mb-1">
              Connexion
            </h5>

            <p className="text-muted small mb-4">
              Connectez-vous pour accéder au
              Dashboard et gérer votre boutique.
            </p>

            <form onSubmit={handleSubmit}>

              {/* EMAIL */}

              <div className="mb-3">
                <label className="form-label small fw-semibold">
                  Adresse email
                </label>

                <input
                  type="email"
                  name="email"
                  className="form-control"
                  value={form.email}
                  onChange={handleChange}
                  placeholder="admin@prosoft-togo.com"
                  required
                  autoComplete="email"
                  disabled={submitting}
                />
              </div>

              {/* PASSWORD */}

              <div className="mb-3">
                <label className="form-label small fw-semibold">
                  Mot de passe
                </label>

                <input
                  type="password"
                  name="password"
                  className="form-control"
                  value={form.password}
                  onChange={handleChange}
                  placeholder="Votre mot de passe"
                  required
                  autoComplete="current-password"
                  disabled={submitting}
                />
              </div>

              {/* ERREUR AUTH */}

              {authError && (
                <div className="alert alert-danger py-2 small">
                  Impossible de se connecter.
                  Vérifiez votre email et votre mot
                  de passe.
                </div>
              )}

              {/* BOUTON */}

              <button
                type="submit"
                className="btn btn-primary w-100 py-2"
                disabled={submitting}
              >
                {submitting ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                    />

                    Connexion...
                  </>
                ) : (
                  "Se connecter"
                )}
              </button>
            </form>
          </div>
        </div>

        <p className="text-muted small text-center mt-3 mb-0">
          Accès réservé à l'administration
          ProSoft Tools.
        </p>
      </div>
    </div>
  );
}

export default LoginPage;
